import styled from 'styled-components';

export const SelectLabel = styled.div`
  height: 100%;
  width: 100%;
`;
